<template>
  <header class="header">
    <div class="container">
      <div class="logo">
        <a :href="hostname == '192.168.9.7' ? './' : '/'" target="_top"
          ><img
            :src="conf.THEME_PATH + '/assets/theme/img/LOGOTL.png'"
            alt=""
        /></a>
      </div>
    </div>
  </header>
</template>

<script>
import MyConfig from "@/../me.config.js";

export default {
  name: "Header",
  data() {
    return {
      hostname: location.hostname,
      conf: MyConfig,
    };
  },
};
</script>
